import React from "react";

interface FormFieldProps {
  label: string;
  name: string;
  type?: string;
  required?: boolean;
  value: string;
  error?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormField: React.FC<FormFieldProps> = ({
  label,
  name,
  type = "text",
  value,
  error,
  onChange,
}) => {
  return (
    <div className="flex flex-col gap-y-2.5 items-start text-lg sm:text-xl leading-normal">
      <label htmlFor={name} className="block">
        {label} 
      </label>
      <input
        type={type}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        className={`border ${
          error 
            ? "border-error bg-error/5"
            : "border-midGrey bg-cream"
        } rounded-md w-full px-4 py-2.5 active:border-grey focus:outline-none focus:outline-black focus:outline-2 focus:outline-solid focus:outline-offset-0`}
      />
      {error && <span className="text-error">{error}</span>}
    </div>
  );
};

export default FormField;